import apiRequest from './client';

export const listMarriageGratisTiers = ({ group, bank } = {}) => {
  const params = new URLSearchParams();
  if (group) params.set('group', group);
  else if (bank) params.set('bank', bank);
  return apiRequest(`/marriage-gratis-tiers/?${params.toString()}`);
};

export const createMarriageGratisTier = (data) =>
  apiRequest('/marriage-gratis-tiers/', { method: 'POST', body: data });

export const updateMarriageGratisTier = (id, data) =>
  apiRequest(`/marriage-gratis-tiers/${id}/`, { method: 'PATCH', body: data });

export const deleteMarriageGratisTier = (id) =>
  apiRequest(`/marriage-gratis-tiers/${id}/`, { method: 'DELETE' });
